/* global COGNITO_AUTH_USERNAME, COGNITO_AUTH_PASSWORD */

import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

export const AmplifyToken = {
  getToken () {
    return Auth.currentSession()
      .then(data => {
        return data.accessToken.jwtToken;
      })
      .catch(async (err) => {
        console.log('err', err);
        const result = await this.signIn();
        return result;
      });
  },
  async signIn () {
    try {
      const username = COGNITO_AUTH_USERNAME;
      const password = COGNITO_AUTH_PASSWORD;
      const user = await Auth.signIn(username, password);
      if (user.challengeName === 'MFA_SETUP') {
        // This happens when the MFA method is TOTP
        // The user needs to setup the TOTP before using it
        // More info please check the Enabling MFA part
        Auth.setupTOTP(user);
      } else {
        // The user directly signs in
        console.log(user);
        return this.getToken();
      }
    } catch (err) {
      if (err.code === 'UserNotConfirmedException') {
        // The error happens if the user didn't finish the confirmation step when signing up
        // In this case you need to resend the code and confirm the user
        // About how to resend the code and confirm the user, please check the signUp part
      } else if (err.code === 'PasswordResetRequiredException') {
        // The error happens when the password is reset in the Cognito console
        // In this case you need to call forgotPassword to reset the password
        // Please check the Forgot Password part.
      } else if (err.code === 'NotAuthorizedException') {
        // The error happens when the incorrect password is provided
      } else if (err.code === 'UserNotFoundException') {
        // The error happens when the supplied username/email does not exist in the Cognito user pool
      } else {
        console.log(err);
      }
    }
  }
};
